var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-input",
    _vm._g(
      {
        staticClass: "searchClass",
        attrs: {
          placeholder: "搜索",
          "suffix-icon": "iconfont u8-search",
          value: _vm.value,
          size: _vm.size,
        },
      },
      _vm.listeners
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }